var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "79px",
    viewBox: "0 0 79 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3.0 Icons / Filled / Warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.0-Modals-/-Joined-(Invite-Sent)-[D]",
    transform: "translate(-270.000000, -44.000000)",
    fill: "#1E1450",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-Icons-/-Filled-/-Warning",
    transform: "translate(263.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5,7.75 C25.11,7.75 7.75,25.11 7.75,46.5 C7.75,67.89 25.11,85.25 46.5,85.25 C67.89,85.25 85.25,67.89 85.25,46.5 C85.25,25.11 67.89,7.75 46.5,7.75 Z M38.75,65.875 L19.375,46.5 L24.83875,41.03625 L38.75,54.90875 L68.16125,25.4975 L73.625,31 L38.75,65.875 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.0223c5c28e2e06dbfdd325d009c86e3b.svg";
export { ForwardRef as ReactComponent };